import React, { useContext, useEffect } from "react";
import $ from "jquery";
import axios from "axios";
import AccordionItem from "./AccordionItem";
import { MainContext } from "./../../context/main-context";
import { DataContext } from "../../context/data-context";

import { Accordion } from "react-bootstrap";

import { FaCar, FaBus, FaTheaterMasks, FaShieldAlt } from "react-icons/fa";
const RightPanelItems = () => {
  const items = [


    {
      id: 200,
      title: "حمل و نقل شخصی",
      icon: <FaCar color="#2d2d2d" className="ms-1" />,
      subItems: [
        {
          id: 201,
          title: "ترافیک",
          name: "terafic",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },



        {
          id: 203,
          title: "طرح",
          name: "TARH",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },

        {
          id: 204,
          title: "پمپ بنزین",
          name: "FUEL",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 205,
          title: "پمپ گاز طبیعی",
          name: "CNG",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },

      ],
    },

    {
      id: 300,
      title: "حمل و نقل عمومی",
      icon: <FaBus color="#2d2d2d" className="ms-1" />,
      subItems: [
        {
          id: 301,
          title: "مترو",
          name: "metro",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 302,
          title: "BRT",
          name: "BRT",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 303,
          title: "اتوبوس",
          name: "BUS",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 304,
          title: "تاکسی",
          name: "taxi",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
      ],
    },

    {
      id: 400,
      title: "امکانات رفاهی",
      icon: <FaTheaterMasks color="#2d2d2d" className="ms-1" />,
      subItems: [
        {
          id: 401,
          title: "مدارس",
          name: "SCHOOL",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },

        {
          id: 403,
          title: "پارک و فضای سبز",
          name: "PARK",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 404,
          title: "داروخانه",
          name: "PHARMACY",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 405,
          title: "مجموعه ورزشی",
          name: "GYM",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 406,
          title: "استخر",
          name: "POOL",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 407,
          title: "مراکز خرید",
          name: "SHOP",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 409,
          title: "هتل و اقامتگاه",
          name: "HOTEL",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },

        {
          id: 410,
          title: "باغ وحش",
          name: "ZOO",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
      ],
    },
    {
      id: 500,
      title: "ایمنی محیطی",
      icon: <FaShieldAlt color="#2d2d2d" className="ms-1" />,
      subItems: [
        {
          id: 501,
          title: "پلیس",
          name: "POLICE",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 502,
          title: "آتش نشانی",
          name: "FIRE",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 503,
          title: "مراکز درمانی",
          name: "HOSPITAL",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
        {
          id: 505,
          title: "پناه گاه ها",
          name: "BOHRAN",
          btns: {
            map: true,
            calc: false,
            chart: false,
          },
        },
      ],
    },

  ];

  const dataContext = useContext(DataContext);
  const mainContext = useContext(MainContext);

  let dataCat = [];
  let cat200, cat300, cat400, cat500;
  if ($.isEmptyObject(dataContext.dataCat200)) {
    cat200 = [];
  } else {
    cat200 = dataContext.dataCat200;
  }
  if ($.isEmptyObject(dataContext.dataCat300)) {
    cat300 = [];
  } else {
    cat300 = dataContext.dataCat300;
  }
  if ($.isEmptyObject(dataContext.dataCat400)) {
    cat400 = [];
  } else {
    cat400 = dataContext.dataCat400;
  }
  if ($.isEmptyObject(dataContext.dataCat500)) {
    cat500 = [];
  } else {
    cat500 = dataContext.dataCat500;
  }

  dataCat.push(cat200, cat300, cat400, cat500);

  // let cat200 = dataContext.dataCat200;
  // if ($.isEmptyObject(dataContext.dataCat200)) cat200 = [];

  const AccordionClickHandler = async (id) => {
    await dataContext.SetClickedPointDataOld(dataContext.clickedPointData);
    // cat data fetching
    if (id == 200) gettigDataCat(["per", dataContext.SetDataCat200]);
    else if (id == 300) gettigDataCat(["pub", dataContext.SetDataCat300]);
    else if (id == 400) gettigDataCat(["ref", dataContext.SetDataCat400]);
    else if (id == 500) gettigDataCat(["sec", dataContext.SetDataCat500]);
  };
  const gettigDataCat = (input) => {
    // real request syntax :

    //check if user clicked on map or not
    if (!$.isEmptyObject(dataContext.clickedPointData)) {
      const params = new URLSearchParams();
      const [lng, lat] = dataContext.clickedPointData.data.geom.coordinates;
      //lng and lat are string should convert to num
      params.append("lat", +lat);
      params.append("lon", +lng);
      // sec //per //pub //ref
      axios
        .post(`https://mahalino.sedrehgroup.ir/api/${input[0]}`, params)
        .then((res) => {
          if (input[0] == "pub") {
            const busLinesData = res.data.find((item) => item.id == 305); // busLines is 305
            mainContext.setBusLinesData(busLinesData);
          }
          input[1](res.data);
        })

        .catch((err) => console.log(err));
    }
  };
  const isShow = mainContext.showFirstCat;
  useEffect(() => {
    // AccordionClickHandler(dataContext.openedCat);
  });
  const setteingCatId = async (id) => {
    await dataContext.SetOpenedCat(id);
  };
  return (
    <>
      <Accordion flush defaultActiveKey={isShow ? 0 : null}>
        {items.map((item, index) => (
          <AccordionItem
            staticValue={item}
            dynamicValue={dataCat[index]}
            key={index}
            index={index}
            id={item.id}
            onClick={() => setteingCatId(item.id)}
            AccordionHeaderHandler={() => AccordionClickHandler(item.id)}
          />
        ))}
      </Accordion>
    </>
  );
};
let CollapseItems;
export default CollapseItems = React.memo(RightPanelItems);
